/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { ParentSize } from "@visx/responsive";
import { Row } from "react-awesome-styled-grid";
import { Box, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { BrickLoader, LoaderWrap, SpendsChart } from "~/components";

type Props = {
  loading: boolean;
  currentMonthCosts: string[];
  events: React.ComponentProps<typeof SpendsChart>["events"];
};

export function CostDetailsTab({ currentMonthCosts, loading, events }: Props) {
  return (
    <Row>
      <Box spacing="spacing04">
        <Box
          boxStyle="grey"
          px={theme.spacing.spacing03}
          py={theme.spacing.spacing02}
          spacing="spacing04"
        >
          <FlexContainer justifyContent="space-between">
            <Text size="sm" tag="div" weight="medium">
              Monthly Costs vs. Application Events
            </Text>
          </FlexContainer>
        </Box>
        <LoaderWrap
          loading={loading}
          Component={BrickLoader}
          viewBox="0 0 10 4"
          style={{ height: "auto" }}
        >
          <ParentSize>
            {({ width }) => (
              <SpendsChart
                width={width}
                height={280}
                spends={currentMonthCosts}
                events={events}
              />
            )}
          </ParentSize>
        </LoaderWrap>
      </Box>
    </Row>
  );
}
